module.exports = __webpack_public_path__ + "img/planning-ppp.edd965f1.png";